<template>
  <!-- ok保增员活动 -->
  <div class="recruiting-activity">
    <div class="activityTop">
      <img src="@/static/images/activityCenter/ok-banner1.png" alt="" class="ok-banner" />
      <img src="@/static/images/activityCenter/ok-rulers.png" alt="" class="ok-rulers" @click="$router.push('/apps/activityCenter/okApp/partnershipRule')" />
      <img src="@/static/images/activityCenter/invitation.png" alt="" class="invitation" @click="$refs.activityShare.open()" />
    </div>
    <div class="activityCenter">
      <div class="invitate">
        <div class="btns">
          <div class="btn-item" @click="$app.router({ url: `fqtd://increaseStaffPoster` })">
            <img src="@/static/images/activityCenter/haibao.png" alt="" />
            发送海报邀请 
          </div>
          <div class="btn-item" @click="visiable=!visiable">
            <img src="@/static/images/activityCenter/erweima.png" alt="" />
            面对面邀请
          </div>
        </div>
        <div class="message">
          分享链接或海报，好友注册，与您绑定推荐关系
        </div>
      </div>
      <div class="myAddition">
        <div class="myAdditionTop">
          <img src="@/static/images/activityCenter/my.png" alt="" class="my" />
          <span class="goToDetail" @click="goToDetail()">详情<img src="@/static/images/activityCenter/right.png" alt="" class="my" /></span>
        </div>
        <div class="myAdditionData">
          <div class="item" @click="goToDetail(1)">
            <span class="num">{{recruitmentData.intentionalCount}}</span>
            <span>有意向</span>
          </div>
          <div class="item" @click="goToDetail(2)">
            <span class="num">{{recruitmentData.unsignedCount}}</span>
            <span>未签约</span>
          </div>
          <div class="item" @click="goToDetail(3)">
            <span class="num">{{recruitmentData.signedCount}}</span>
            <span>待出单</span>
          </div>
          <div class="item" @click="goToDetail(4)">
            <span class="num">{{recruitmentData.issuedOrderCount}}</span>
            <span>已出单</span>
          </div>
        </div>
        
      </div>
      <div class="image-item">
        <img src="@/static/images/activityCenter/image1.png" alt="" class="image1" />
      </div>
      <div class="image-item">
        <img src="@/static/images/activityCenter/image2.png" alt="" class="image2" />
      </div>
      <div class="content">最终解释权归梧桐树保险经纪有限公司所有</div>
    </div>
    <div class="modal" :class="visiable?'':'none'">
      <div class="modalContent"  ref="imgContainer">
        <div class="modalContentCenter">
          <div class="top">
            扫码加入OK保  领高额收益
          </div>
          <div class="erweima" :data-html2canvas-ignore="true">
            <vueQr ref="vueQr" :text="h5Link" v-if="h5Link" :margin="0" :width="200" />
          </div>
          <div class="btn" @click="downloadCode" :data-html2canvas-ignore="true">保存图片</div>
        </div>
      </div>
      <van-icon name="close"
                class="img-product-icon"
                color="#fff"
                size="40"
                @click="visiable=false" />
    </div>
    <ok-activity-share ref="activityShare" :download="false"></ok-activity-share>
  </div>
</template>
<script>
import vueQr from 'vue-qr';
import okActivityShare from '@/components/okActivityShare';
import html2Canvas from 'html2canvas';
export default {
  components: {okActivityShare,vueQr},
  data() {
    return{
      h5Link: '',
      visiable:false,
      userInfo:JSON.parse(localStorage.getItem('jzy_user')),
      recruitmentData:{},
      userType:null
    }
  },
  mounted() {
    this.init();
    this.getRecruitmentData()
  },
  methods: {
    async goToDetail(val){
      console.log('111111',val,this.userType);
      if(this.userType !=2){
        // 未签约用户
        const topOrgId = await this.getTopId(this.userInfo.orgId);
        location.href = location.origin + `/apps/sign/leaflet?orgId=${topOrgId}`;
      }else{
        console.log('点击'+val);
        this.$router.push({path:'/apps/activityCenter/okApp/recruitingActivity/myAddition',query:{firstType:val,time:JSON.stringify(new Date())}});
      }
    },
    // 获取增员数据
    getRecruitmentData() {
      this.$http({
        type: 'GET',
        url: '/app/okbao/userIncrease/statistic',
        data: {
          userId:this.userInfo.userId
        }
      }).then(res => {
        if (res.data) {
          this.recruitmentData = res.data;
        }
      });
    },
    downloadCode() {
      html2Canvas(this.$refs['imgContainer'], {
          allowTaint: false,
          taintTest: false,
          logging: false,
          useCORS: true,
          dpi: Number(document.documentElement.getAttribute('data-dpr')) * 4, // 将分辨率提高到特定的DPI 提高四倍
          scale: 4 // 按比例增加分辨率
        }).then(canvas => {
          const context = canvas.getContext('2d');
          // 关闭抗锯齿形
          context.mozImageSmoothingEnabled = false;
          context.webkitImageSmoothingEnabled = false;
          context.msImageSmoothingEnabled = false;
          context.imageSmoothingEnabled = false;
          // canvas转化为图片
          this.canvas2Image(canvas, 600, parseInt((canvas.height / canvas.width) * 600));
        });
    },
    canvas2Image(canvas, width, height) {
      const that = this;
      const retCanvas = document.createElement('canvas');
      const retCtx = retCanvas.getContext('2d');

      const image2 = new Image();
      
      image2.setAttribute('crossOrigin', 'anonymous');
      image2.src = that.$refs.vueQr.$el.src;

      image2.onload = function () {
        retCanvas.width = width;
        retCanvas.height = height;
        retCtx.drawImage(canvas, 0, 0, width, height);
        retCtx.drawImage(image2, 125, 160, 350, 350);
        if (that.$config.isApp) {
          that.upload(retCanvas.toDataURL('image/jpeg'));
        } else {
          that.downloadImg(retCanvas.toDataURL('image/jpeg')); 
        }
      }
      
      
      that.show = false;
    },
    upload(baseStr) {
      let blob = this.dataURLtoFile(baseStr, 'image/jpeg');
      var formData = new FormData();
      let fileOfBlob = new File([blob], new Date() + '.jpg'); // 重命名了
      formData.append('faceInfo', fileOfBlob);
      const loading = this.$notice.loading('下载中')
      this.$http({
        url: '/resmgr/upload',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.$app.download(
          {
            type: 'image',
            url: res.data[0].path
          },
          res => {
            this.$notice.msg('保存成功');
          },
          res => {
            this.$notice.msg('保存失败');
          }
        );
        return;
      }).finally(()=>{
        this.$notice.hideLoading(loading)
      });
    },
    dataURLtoFile(dataURI, type) {
      let binary = atob(dataURI.split(',')[1]);
      let array = [];
      for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], { type: type });
    },
    downloadImg(Url) {
      const fileName = '面对面扫码邀好友.jpg';
      //IE10以上支持blob但是依然不支持download
      if ('download' in document.createElement('a')) {
        //支持a标签download的浏览器
        const link = document.createElement('a'); //创建a标签
        link.download = fileName; //a标签添加属性
        link.style.display = 'none';
        link.href = Url;
        document.body.appendChild(link);
        link.click(); //执行下载
        URL.revokeObjectURL(link.href); //释放url
        document.body.removeChild(link); //释放标签
      } else {
        //其他浏览器
        navigator.msSaveBlob(Url, fileName);
      }
    },
    async init() {
      const topOrgId = await this.getTopId(this.userInfo.orgId);
      this.userType = this.userInfo.userType;
      this.h5Link = location.origin + `/apps/signRegister?orgId=${topOrgId}&userId=${this.userInfo.userId}&noCheck=1`;
      if (this.$config.isApp) {
        await this.getLink();
      }
      this.shareData = {
        type: 1,
        title: '下载OK保，一起来赚钱吧！',
        link: this.h5Link,
        content: '登陆CCTV大品牌，千款优质好保险，精选好产品，理赔更无忧！', //分享的描述,
        logo: 'https://file-test.lazhuyun.cn/upload/20230904/1693820572564020449.png'
      };
      this.$weixin.share(this.shareData);
    },
    getLink() {
      return this.$http({
        url: '/api/tools/transformLongUrl',
        type: 'PUT',
        data: { 
          type: 1,
          url: this.h5Link 
        }
      }).then(res => {
        this.h5Link = res.data;
      });
    },
    // 获取商户机构id
    getTopId(orgId) {
      return this.$http({
        url: '/api/userAuth/queryOrgIdBySub',
        type: 'GET',
        data: {
          subOrgId: orgId
        }
      }).then(res => {
        return res.data;
      });
    },
    share(target) {
      const shareData = {
        type: 1,
        title: '下载OK保，一起来赚钱吧！',
        link: this.h5Link,
        content: '登陆CCTV大品牌，千款优质好保险，精选好产品，理赔更无忧！', //分享的描述,
        logo: 'https://file-test.lazhuyun.cn/upload/20230904/1693820572564020449.png'
      };
      if (this.$config.isApp) {
        this.$app.openShare({
          ...shareData,
          target
        });
      } else {
        this.visible = false;
        this.showYindao = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.recruiting-activity {
  background: #F21400;
  .activityTop{
    width: 100%;
    position: relative;
    .ok-banner{
      width: 100%;
    }
    .ok-rulers{
      height: 50px;
      position: absolute;
      top: 20px;
      right: 0;
    }
    .invitation{
      position: absolute;
      bottom: -50px;
      left: calc(50vw - 283px);
      width: 566px;
      height: 110px;
    }
  }
  .activityCenter{
    width: 100%;
    .invitate{
      width: 670px;
      height: 230px;
      margin: 0 40px;
      border-radius: 20px;
      background: #FC4A38;
      overflow:hidden;
      .btns{
        width: 638px;
        height: 140px;
        margin: 16px;
        background: #FFFFFF;
        border-radius: 12px;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        color: #883F0A;
        font-size: 28px;
        .btn-item{
          display: flex;
          align-items: center;
          line-height: 80px;
          z-index: 10;
        }
        img{
          width:36px;
          height: 36px;
          padding-right: 6px;
        }
      }
      .message{
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        opacity: 0.7;
        font-size: 24px;
      }
    }
    .myAddition{
      width: 670px;
      margin: 0 40px;
      border-radius: 20px;
      background: #FC4A38;
      margin-top: 30px;
      padding: 16px;
      .myAdditionTop{
        width: 638px;
        height: 90px;
        position: relative;
        .my{
          width: 100%;
        }
        .goToDetail{
          position: absolute;
          right: 20px;
          top: 30px;
          font-size: 26px;
          color: #FF5F00;
          img{
            height: 20px;
            width: 11.25px;
            margin-left: 3px;
          }
        }
      }
      .myAdditionData{
        width: 638px;
        height: 162px;
        background: #ffffff;
        border-radius: 0 0 12px 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        .item{
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #888888;
          font-size: 26px;
          .num{
            color: #EE2127;
            font-size: 40px;
            font-family: PingFang SC;
            font-weight: 600;
          }
        }
      }
    }
    .image-item{
      width: 100%;
      padding: 0 40px;
      .image1{
        width: 670px;
        height: 559px;
        margin-top: 15px;
      }
      .image2{
        width: 670px;
        height: 719px;
      }
    }
    .content{
      padding-top: 30px ;
      padding-bottom: 30px ;
      color: #FBB8B2;
      display: flex;
      justify-content: center;
    }
  }
  .none{
    display: none;
  }
  .modal{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1001;
    background-color:  rgba(0,0,0,0.39);;
    
    .modalContent{
      background: url('~@/static/images/activityCenter/background.png');
      background-size: cover;
      width: 594px;
      height: 624px;
      position: fixed;
      top: 434px;
      left: 0;
      right: 0;
      margin: 0 auto;
      z-index: 1000;
      border-radius: 45px;
      .modalContentCenter{
        width: 560px;
        height: 590px;
        background: linear-gradient(37deg, #FFF5E2 0%, #FFFFFF 100%);
        border: 3px solid #FFD195;
        margin: 17px;
        border-radius: 36px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .top{
          width: 408px;
          height: 66px;
          background: linear-gradient(131deg, #FFF0B4 0%, #FED292 100%);
          border-radius: 0px 0px 20px 20px;
          font-weight: 600;
          font-size: 28px;
          color: #C54F00;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 26px;
        }
      }
      .erweima{
        width: 340px;
        height: 340px;
        img{
          width: 340px;
          height: 340px;
        }
      }
      .btn{
        width: 340px;
        height: 80px;
        background: linear-gradient(222deg, #FD8601 0%, #FC4901 100%);
        border-radius: 40px;
        margin-top: 30px;
        font-weight: 500;
        font-size: 30px;
        color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .img-product-icon {
      width: 100%;
      display: flex;
      justify-content: center;
      position: fixed;
      top: 1139px;
      left: 0;
      right: 0;
      margin: 0 auto;
      z-index: 1000;
    }
  }
}
</style>
